
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11904',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11904",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.455",
  "dashboard-client-types": "static-1.311",
  "data-fetching-client": "static-1.9567",
  "foundations-components": "static-1.7706",
  "foundations-components-legacy": "static-1.731",
  "foundations-theming": "static-1.4304",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.80",
  "head-dlb": "static-1.4921",
  "hs-test-utils": "static-1.7903",
  "hub-http-shared-msw-handlers": "static-1.9715",
  "hubspot-dlb": "static-2.1828",
  "hubspot-url-utils": "static-1.4034",
  "HubStyleTokens": "static-2.11342",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6361",
  "marketplace-storefront-base": "static-1.11965",
  "quartz": "static-1.6856",
  "react-dlb": "static-1.76",
  "react-rhumb": "static-1.16546",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2754",
  "reporting-testing-lib": "static-1.8924",
  "settings-ui-lib": "static-1.12417",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6937",
  "ui-addon-i18n": "static-1.11039",
  "ui-addon-react-router-dom": "static-1.9436",
  "unified-auth": "static-1.338",
  "unified-auth-core-lib": "static-1.619",
  "usage-tracker": "static-1.7228",
  "usage-tracker-core": "static-1.7078",
  "customer-data-property-utils": "static-1.7975",
  "history": "static-4.47",
  "hub-http": "static-1.6110",
  "integrations-lib": "static-1.15761",
  "marketplace-ui-common": "static-1.19279",
  "property-management-iframe": "static-1.12785",
  "quartz-config": "static-1.634",
  "quartz-core": "static-1.6075",
  "quartz-routing": "static-1.286",
  "quick-fetch": "static-1.3826",
  "react": "static-7.184",
  "rpc-client-utils": "static-1.4535",
  "ts-schema": "static-1.3989",
  "ui-universal-auth": "static-1.8824",
  "UIComponents": "static-3.8289",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.425",
  "hs-promise-rejection-tracking": "static-1.5473",
  "PortalIdParser": "static-2.386",
  "raven": "static-3.5808",
  "raven-hubspot": "static-1.6115",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.76",
  "metrics-js": "static-1.9522",
  "react-redux": "static-7.69",
  "redux": "static-4.16",
  "styled-components": "static-2.87",
  "bend-plugin-trellis-migration": "static-1.3317",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3133",
  "quartz-webpack": "static-1.3080",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3975",
  "floating-ui": "static-1.54",
  "foundations-assets": "static-1.4738",
  "foundations-theming-specialty": "static-1.2020",
  "framer-motion": "static-1.70",
  "hs-story-utils": "static-1.9321",
  "react-aria": "static-1.64",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5259",
  "react-virtualized": "static-2.97",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1505",
  "ui-fonts": "static-1.604",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-theming": "static-1.2787",
  "foundations-theming-base": "static-1.3289",
  "stylex": "static-1.30",
  "HeadJS": "static-2.732",
  "hs-test-utils-bend-plugin": "static-1.3014",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4216",
  "ai-components-ui-library": "static-1.8662",
  "ai-rendering-library": "static-1.9683",
  "chirp-fetch": "static-1.1773",
  "connections-embed-lib": "static-1.782",
  "copilot-toolkit": "static-1.10826",
  "laboratory-lib": "static-3.7051",
  "marketplace-embed": "static-1.21770",
  "marketplace-ui-details": "static-1.9175",
  "marketplace-ui-reviews": "static-1.19235",
  "marketplace-ui-tracking": "static-1.13450",
  "sanitize-text": "static-1.8036",
  "ui-addon-video-player": "static-1.8588",
  "usage-tracker-multi": "static-1.5642",
  "usage-tracker-session-replay": "static-1.4914",
  "wootric-nps": "static-1.6876",
  "apollo-link-hub-http": "static-2.4542",
  "immer": "static-1.33",
  "immerable": "static-1.4045",
  "highcharts": "static-8.102",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2427",
  "reporting-data": "static-1.66991",
  "cssUtils": "static-1.764",
  "flux-actions": "static-1.323",
  "HubStyle": "static-2.11650",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10101",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10265",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7218",
  "icons": "static-2.637",
  "marketplace-ui-apps-core": "static-1.17812",
  "storybook-react": "static-1.31",
  "trellis-story-utils": "static-1.4411",
  "foundations-components-test-utils": "static-1.5189",
  "quartz-i18n": "static-1.531",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3625",
  "customer-data-objects": "static-1.7547",
  "property-translator": "static-1.5301",
  "frontend-preferences-client": "static-1.7816",
  "hs-promise-utils": "static-1.5486",
  "hubspot-apollo-client": "static-1.4770",
  "integrations-error-boundary-lib": "static-1.13176",
  "integrations-tracking-lib": "static-1.5487",
  "native-integrations-shared-strings": "static-1.7678",
  "reselect": "static-2.16",
  "sanitize": "static-1.4364",
  "superstore": "static-1.4661",
  "ui-shepherd-react": "static-3.10039",
  "ai-settings-ui-library": "static-1.7710",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4563",
  "immutable-less": "static-1.4545",
  "marketplace-ui-client-types": "static-1.16686",
  "nav-meta": "static-1.29265",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10137",
  "ui-addon-upgrades": "static-9.17826",
  "inbound-db-properties-service-client": "static-1.3757",
  "property-management-common": "static-1.5073",
  "ui-addon-iframeable": "static-1.8941",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.531",
  "quartz-head": "static-1.521",
  "quartz-test": "static-1.531",
  "quartz-tracking": "static-1.235",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3057",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20780",
  "ContentUtils": "static-1.68014",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2385",
  "customer-data-filters-ui": "static-1.39320",
  "customer-data-objects-ui-components": "static-1.12910",
  "customer-data-reference-ui-components": "static-1.13045",
  "embedded-academy-lib": "static-1.13932",
  "ExportDialog": "static-6.10282",
  "highlight.js": "static-1.77",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40957",
  "reporting-snowflake": "static-1.55609",
  "reporting-ui-components": "static-2.64262",
  "reporting-visualizations": "static-1.59067",
  "ui-addon-teams": "static-1.21397",
  "magpie-lib": "static-1.5485",
  "magpie-types": "static-1.4945",
  "simple-logging-lib": "static-1.2943",
  "navigation-components": "static-1.17628",
  "ai-studio-lib": "static-1.11291",
  "app-governance-lib": "static-1.1212",
  "developer-experience-shared-components": "static-1.10398",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7883",
  "ui-product-approvals": "static-1.27824",
  "ui-tool-access": "static-1.10038",
  "usage-based-billing-components-lib": "static-1.8308",
  "usage-tracker-anonymous": "static-1.5645",
  "usage-tracker-public": "static-1.7039",
  "amplitude-session-replay-browser": "static-1.58",
  "inbound-db-meta-service-client": "static-1.3500",
  "persist-promise": "static-1.3600",
  "reference-resolvers": "static-1.8058",
  "ui-extensibility-client-types": "static-1.3831",
  "hubspot-apollo-cache": "static-1.229",
  "universal-page-editor-lib": "static-1.2898",
  "final-form": "static-1.68",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2471",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4962",
  "purchase-motions-components": "static-1.5667",
  "salesImages": "static-1.523",
  "batch-promise": "static-1.1443",
  "crm-component-utils": "static-1.38772",
  "crm-properties-common-lib": "static-1.5766",
  "customer-data-properties": "static-1.51159",
  "framework-data-schema-resolvers": "static-1.6767",
  "property-value-citations": "static-1.1773",
  "reference-resolvers-lite": "static-1.7981",
  "navigation-messaging": "static-1.6955",
  "hubspotter-http-shared-msw-handlers": "static-1.9713",
  "cms-field-types": "static-1.4701",
  "content-icons-ui": "static-1.2196",
  "conversations-skeleton-state": "static-1.7141",
  "crm-message-bus": "static-1.42681",
  "customer-data-filters-ui-msw-helpers": "static-1.21755",
  "customer-data-ui-utilities": "static-1.9717",
  "FormUrlGenerator": "static-2.4611",
  "framework-builder-read-service-client": "static-1.3919",
  "framework-data-schema-quick-fetch": "static-1.6672",
  "multi-account-reference-resolvers": "static-1.873",
  "onboarding-tours": "static-1.16403",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13364",
  "academy-common-lib": "static-1.13392",
  "content-assistance-lib": "static-1.7590",
  "dashboard-lib": "static-1.81070",
  "file-manager-components": "static-1.23274",
  "getting-started-shared-tasks": "static-1.18189",
  "hubspot-prosemirror": "static-1.17923",
  "hubspot-prosemirror-plugins": "static-1.17915",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19645",
  "share-with-third-party-component-lib": "static-1.8586",
  "ui-addon-draggable": "static-3.4661",
  "ui-asset-management-lib": "static-1.10865",
  "ui-business-units-lib": "static-1.8931",
  "user-context": "static-1.4991",
  "growth-payments-core": "static-1.25041",
  "reporting-plugins": "static-1.10125",
  "reporting-reports": "static-1.66669",
  "idb-keyval": "static-1.42",
  "reactive-lib": "static-1.616",
  "nest": "static-1.113",
  "codemirror": "static-5.93",
  "feedback-loader": "static-1.29096",
  "react-codemirror": "static-1.10515",
  "framework-listing-lib": "static-2.28352",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30422",
  "apps-service-types": "static-1.3769",
  "oauth-service-types": "static-1.4140",
  "onboarding-scopes": "static-1.6355",
  "onboarding-tours-client": "static-1.4617",
  "platform-infra-nav-components": "static-1.7577",
  "subscription-experience-data-types": "static-1.14715",
  "crm-record-cards-service-types": "static-1.3521",
  "location-customization-utils-lib": "static-1.8899",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4393",
  "nav-client-types": "static-1.2250",
  "purchase-motions-api": "static-1.5670",
  "signup-constants": "static-1.18641",
  "signup-ui-url-generator": "static-2.7931",
  "trials-service-types": "static-1.3794",
  "card-properties-lib": "static-1.43843",
  "commerce-subscription-lib": "static-1.36778",
  "crm-actions": "static-1.6206",
  "crm-cards-sdk": "static-1.43249",
  "customer-data-properties-shared-msw-handlers": "static-1.9042",
  "customer-data-tracking": "static-1.6775",
  "hs-resources": "static-1.29",
  "pulse": "static-1.428",
  "calling-global-api": "static-1.64085",
  "calling-internal-common": "static-1.31193",
  "calling-lifecycle-internal": "static-1.65467",
  "calling-lifecycle-messages": "static-1.57761",
  "commerce-products-lib": "static-1.9134",
  "conditional-properties-service-client": "static-1.3708",
  "crm-links": "static-1.6167",
  "external-options-client-types": "static-1.4069",
  "google-libphonenumber": "static-1.36",
  "inbounddb-objects-service-types": "static-1.4134",
  "meetings-icalendar-utils-lib": "static-1.522",
  "multi-currency-client-types": "static-1.3600",
  "object-builder-ui-client": "static-1.48374",
  "pipeline-validation-client-types": "static-1.3876",
  "smart-property-lib": "static-1.6410",
  "tiered-pricing": "static-1.998",
  "ui-addon-form-validation": "static-1.10883",
  "crm-pipelines-api-client-types": "static-1.4053",
  "react-dnd-compat": "static-1.4510",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5263",
  "growth-onboarding-confetti": "static-1.2963",
  "growth-onboarding-next-action-utils": "static-1.1596",
  "onboarding-tours-utils": "static-1.469",
  "ui-shepherd-tracker": "static-1.7420",
  "academy-service-client": "static-1.3572",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28236",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8274",
  "video-components-external": "static-1.10923",
  "video-data-lib": "static-1.34581",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8438",
  "payment-link-components": "static-1.23222",
  "ui-addon-emoji-picker": "static-1.9779",
  "EmailSignatureEditor": "static-1.24137",
  "viral-links-lib": "static-1.6930",
  "data-token-picker": "static-1.16216",
  "FileManagerLib": "static-1.38914",
  "react-flip-move": "static-1.68",
  "timezone-utils": "static-2.5136",
  "getting-started-shared-tasks-store": "static-1.17307",
  "campaign-roi-lib": "static-1.8618",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7215",
  "customer-data-views-management": "static-1.25207",
  "framework-data-table": "static-2.11660",
  "marketing-platform-lib": "static-1.6741",
  "nudge-client-utils": "static-1.2345",
  "nudge-custom-ui-functions": "static-1.838",
  "app-users-service-client": "static-1.5448",
  "app-users-service-types": "static-1.4856",
  "mini-checkout-client": "static-1.26542",
  "onboarding-utils": "static-1.5243",
  "permissions-shared-i18n-strings-fe": "static-1.1999",
  "ui-coaching-tips-shared-config": "static-1.28221",
  "edison-service-client-types": "static-1.279",
  "eligibility-engine-service-types": "static-1.3075",
  "crm_data": "static-4.91605",
  "customer-data-sidebar": "static-2.45703",
  "enrichment-properties-lib": "static-1.15528",
  "commerce-billing-lib": "static-1.18777",
  "commerce-shared-components-lib": "static-1.18245",
  "commerce-tools-ui-lib": "static-1.10089",
  "crm-fe-perf": "static-1.22794",
  "directed-graph": "static-1.829",
  "event-emitter": "static-1.840",
  "fast-json-patch": "static-1.61",
  "calling-error-reporting": "static-1.31199",
  "shared-worker-versioning": "static-1.10930",
  "calling-usage-tracker": "static-1.6433",
  "voice-sms-access-library": "static-1.577",
  "commerce-permissions": "static-1.657",
  "products-iframe-lib": "static-1.7624",
  "products-ui-components-shared-msw-handlers": "static-1.10097",
  "data-agent-kit": "static-1.20",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9798",
  "policy-lib": "static-1.6674",
  "react-tinymce": "static-1.54925",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9861",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54051",
  "tinymce-plugins": "static-1.57165",
  "tinymce-themes": "static-1.56021",
  "onboarding-data-sync-lib": "static-1.1779",
  "growth-onboarding-next-action-components": "static-1.1624",
  "user-context-client": "static-1.4503",
  "growth-onboarding-feedback-components": "static-1.6473",
  "content-media-composition-data-lib": "static-1.11878",
  "content-media-compositions": "static-2.15885",
  "media-bridge-lib": "static-1.18736",
  "commerce-tours-lib": "static-1.5895",
  "growth-onboarding-reliability": "static-1.4978",
  "sales-checkout-service-client": "static-1.3560",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21484",
  "sales-email-signature-service-client": "static-1.3735",
  "audio-components": "static-1.5753",
  "FileManagerCore": "static-1.38773",
  "FileManagerImages": "static-1.36425",
  "video-components": "static-1.12926",
  "crm-export-dialog": "static-1.6187",
  "crm-index-associations-lib": "static-1.6327",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1626",
  "tanstack-virtual": "static-1.28",
  "nudge-custom-function-registry": "static-1.2102",
  "nudge-renderer-utils": "static-1.2421",
  "whisper-core-api": "static-1.6284",
  "InboxConnectUtils": "static-4.14510",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5271",
  "settings-content-modals": "static-1.45767",
  "crm_universal": "static-1.21818",
  "customer-data-email": "static-1.17846",
  "card-payment-highlight-lib": "static-1.36832",
  "card-subscription-highlight-lib": "static-1.39201",
  "commerce-contract-lib": "static-1.11577",
  "invoices-highlight-card-lib": "static-1.54357",
  "orders-highlight-card-lib": "static-1.21151",
  "products-highlight-card-lib": "static-1.17418",
  "quotes-highlight-card-lib": "static-1.71573",
  "breeze-intelligence-kit": "static-1.5464",
  "crm-source-interpretation-lib": "static-1.5226",
  "utility-belt": "static-1.2431",
  "payments-enrollment-embed-lib": "static-1.22319",
  "stripe-embedded-components": "static-1.7315",
  "customer-data-rte": "static-1.32714",
  "cv-backend-services": "static-1.1536",
  "growth-onboarding-empty-states": "static-1.5517",
  "payments-post-enroll-local-storage-lib": "static-1.5003",
  "qrcode-generator": "static-1.67",
  "quotes-client-types": "static-1.37663",
  "calling-orchestration-schema": "static-1.35354",
  "sales-views-client-types": "static-1.4155",
  "hub-http-contrib": "static-1.2935",
  "interframe": "static-3.4655",
  "tinymce-data": "static-1.40136",
  "ui-addon-sales-email": "static-1.5103",
  "layout-dnd-components": "static-1.12236",
  "layout-dnd-utils": "static-1.11211",
  "ui-brand-identity-lib": "static-1.14745",
  "NamespacedHubStyle": "static-2.8979",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4423",
  "video-embed": "static-1.35415",
  "social-insights-client-types": "static-1.21752",
  "deal-intel-utils": "static-1.1630",
  "checkout-sdk": "static-3.23385",
  "checkout-service-types": "static-1.3738",
  "company-details-components": "static-1.6077",
  "payment-method-components": "static-1.6788",
  "pricing-pages-ui-components": "static-1.13229",
  "quote-checkout-service-types": "static-1.3366",
  "upgrade-catalog-service-types": "static-1.3418",
  "access-control-lib": "static-1.10330",
  "EmailComponents": "static-1.54453",
  "EmailData": "static-1.53130",
  "redux-less": "static-2.9376",
  "sequences-lib": "static-1.7855",
  "ui-gdpr-components": "static-1.10240",
  "products-ui-components": "static-1.39653",
  "quotes-ui-lib": "static-1.80294",
  "accounting-integrations-ui-components": "static-1.6888",
  "invoices-ui-lib": "static-1.54373",
  "commerce-products-api": "static-1.2124",
  "invoices-iframe-lib": "static-1.56431",
  "quotes-modal-lib": "static-1.102251",
  "stripe-connect-js": "static-1.66",
  "draft-content-plugins": "static-1.27982",
  "ContentData": "static-1.68089",
  "layout-data-lib": "static-1.9536",
  "outpost": "static-1.4087",
  "hub-http-rxjs": "static-1.782",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3822",
  "billing-payments-client-types": "static-1.3881",
  "account-and-billing-fintech-outages": "static-3.18369",
  "pricing-pages-api": "static-1.13094",
  "ContentComponents": "static-2.70970",
  "marketing-contacts-lib": "static-1.9499",
  "marketing-email-service-types": "static-1.1835",
  "messaging-editing-lib": "static-1.45926",
  "messaging-usage-based-billing-components-lib": "static-1.788",
  "automation-ui-source-apps": "static-1.18547",
  "automation-ui-types": "static-1.19465",
  "messaging-types-lib": "static-1.45663",
  "onboarding-settings-client": "static-1.4395",
  "sequences-client-types-lib": "static-1.7712",
  "commerce-tax-lib": "static-1.411",
  "property-description-translator": "static-1.3746",
  "SalesContentIndexUI": "static-3.9071",
  "commerce-analytics-service-client": "static-1.3548",
  "totals-ui-components": "static-1.23269",
  "advanced-menus-core": "static-1.14959",
  "advanced-menus-lib": "static-1.11922",
  "ui-memberships-settings-lib": "static-1.33743",
  "demographics-service-types": "static-1.1543",
  "automation-ui-ubb": "static-1.5381",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7232",
  "data-token-views": "static-1.16197",
  "forms-utils-lib": "static-1.12375",
  "payments-embed-points-lib": "static-1.12816",
  "simple-menus-core": "static-1.14958",
  "simple-menus-lib": "static-1.16475",
  "ui-addon-draggable-compat": "static-2.4146",
  "videoconference-integration-components": "static-1.6664",
  "automation-applications-service-types": "static-1.3413",
  "automation-platform-service-types": "static-1.2549",
  "ContentEditorUI": "static-2.76794",
  "short-messages-app-service-client": "static-1.3877",
  "web-interactives-components": "static-1.13575",
  "web-interactives-data": "static-1.13576",
  "messaging-shared-utils-lib": "static-1.237",
  "messaging-user-info-utils-lib": "static-1.407",
  "email-portal-health-service-types": "static-1.868",
  "FireAlarmUi": "static-1.4421",
  "sales-templates-service-types-lib": "static-1.4077",
  "commerce-totals-service-types": "static-1.3728",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21401",
  "automation-ui-usage-tracking": "static-1.20864",
  "data-studio-ubb": "static-1.2408",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26710",
  "collaboration-sidebar": "static-1.57455",
  "content-management-data-lib": "static-1.5248",
  "copilot-plugins": "static-1.10799",
  "cta-picker": "static-1.36116",
  "customer-agent-discovery-components-lib": "static-1.2746",
  "editor-components": "static-1.13073",
  "editor-iframe-lib": "static-1.8252",
  "error-messaging-js": "static-1.5083",
  "FormsCommonComponents": "static-1.85559",
  "pictos": "static-7.182",
  "react-transition-group": "static-2.63",
  "redux-request-state": "static-1.10538",
  "SharedLegalStrings": "static-1.1644",
  "smart-content-core": "static-1.42145",
  "smart-content-lib": "static-1.42798",
  "social-composer-lib": "static-1.58539",
  "structured-content-lib": "static-1.24900",
  "theme-previewer-lib": "static-1.52955",
  "tinymce-copilot": "static-1.16119",
  "xray-recommendation-lib": "static-1.7747",
  "automation-ui-routing": "static-1.20822",
  "sql-reporting-client-types": "static-1.5552",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41916",
  "campaigns-utils-lib": "static-1.3050",
  "reporting-enablement": "static-1.22483",
  "chatspot-widget-iframe": "static-1.20772",
  "collaboration-sidebar-common": "static-1.2252",
  "forms-ai-lib": "static-1.4149",
  "codemirror-dlb": "static-1.58353",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6320",
  "report-customization-components": "static-1.12817",
  "data-quality-ui-library": "static-1.12587",
  "html-to-image": "static-1.52",
  "reporting-insights-lib": "static-1.1396"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11904",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.455",
  "dashboard-client-types": "/dashboard-client-types/static-1.311",
  "data-fetching-client": "/data-fetching-client/static-1.9567",
  "foundations-components": "/foundations-components/static-1.7706",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.731",
  "foundations-theming": "/foundations-theming/static-1.4304",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.80",
  "head-dlb": "/head-dlb/static-1.4921",
  "hs-test-utils": "/hs-test-utils/static-1.7903",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9715",
  "hubspot-dlb": "/hubspot-dlb/static-2.1828",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4034",
  "HubStyleTokens": "/HubStyleTokens/static-2.11342",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6361",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11965",
  "quartz": "/quartz/static-1.6856",
  "react-dlb": "/react-dlb/static-1.76",
  "react-rhumb": "/react-rhumb/static-1.16546",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2754",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8924",
  "settings-ui-lib": "/settings-ui-lib/static-1.12417",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6937",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11039",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9436",
  "unified-auth": "/unified-auth/static-1.338",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.619",
  "usage-tracker": "/usage-tracker/static-1.7228",
  "usage-tracker-core": "/usage-tracker-core/static-1.7078",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7975",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6110",
  "integrations-lib": "/integrations-lib/static-1.15761",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19279",
  "property-management-iframe": "/property-management-iframe/static-1.12785",
  "quartz-config": "/quartz-config/static-1.634",
  "quartz-core": "/quartz-core/static-1.6075",
  "quartz-routing": "/quartz-routing/static-1.286",
  "quick-fetch": "/quick-fetch/static-1.3826",
  "react": "/react/static-7.184",
  "rpc-client-utils": "/rpc-client-utils/static-1.4535",
  "ts-schema": "/ts-schema/static-1.3989",
  "ui-universal-auth": "/ui-universal-auth/static-1.8824",
  "UIComponents": "/UIComponents/static-3.8289",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.425",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5473",
  "PortalIdParser": "/PortalIdParser/static-2.386",
  "raven": "/raven/static-3.5808",
  "raven-hubspot": "/raven-hubspot/static-1.6115",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.76",
  "metrics-js": "/metrics-js/static-1.9522",
  "react-redux": "/react-redux/static-7.69",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.87",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3317",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3133",
  "quartz-webpack": "/quartz-webpack/static-1.3080",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3975",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4738",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2020",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-story-utils": "/hs-story-utils/static-1.9321",
  "react-aria": "/react-aria/static-1.64",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5259",
  "react-virtualized": "/react-virtualized/static-2.97",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1505",
  "ui-fonts": "/ui-fonts/static-1.604",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2787",
  "foundations-theming-base": "/foundations-theming-base/static-1.3289",
  "stylex": "/stylex/static-1.30",
  "HeadJS": "/HeadJS/static-2.732",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3014",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4216",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8662",
  "ai-rendering-library": "/ai-rendering-library/static-1.9683",
  "chirp-fetch": "/chirp-fetch/static-1.1773",
  "connections-embed-lib": "/connections-embed-lib/static-1.782",
  "copilot-toolkit": "/copilot-toolkit/static-1.10826",
  "laboratory-lib": "/laboratory-lib/static-3.7051",
  "marketplace-embed": "/marketplace-embed/static-1.21770",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9175",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19235",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13450",
  "sanitize-text": "/sanitize-text/static-1.8036",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8588",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5642",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4914",
  "wootric-nps": "/wootric-nps/static-1.6876",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4542",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4045",
  "highcharts": "/highcharts/static-8.102",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2427",
  "reporting-data": "/reporting-data/static-1.66991",
  "cssUtils": "/cssUtils/static-1.764",
  "flux-actions": "/flux-actions/static-1.323",
  "HubStyle": "/HubStyle/static-2.11650",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10101",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10265",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7218",
  "icons": "/icons/static-2.637",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17812",
  "storybook-react": "/storybook-react/static-1.31",
  "trellis-story-utils": "/trellis-story-utils/static-1.4411",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5189",
  "quartz-i18n": "/quartz-i18n/static-1.531",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3625",
  "customer-data-objects": "/customer-data-objects/static-1.7547",
  "property-translator": "/property-translator/static-1.5301",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7816",
  "hs-promise-utils": "/hs-promise-utils/static-1.5486",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4770",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13176",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5487",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7678",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4364",
  "superstore": "/superstore/static-1.4661",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10039",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7710",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4563",
  "immutable-less": "/immutable-less/static-1.4545",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16686",
  "nav-meta": "/nav-meta/static-1.29265",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10137",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17826",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3757",
  "property-management-common": "/property-management-common/static-1.5073",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8941",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.531",
  "quartz-head": "/quartz-head/static-1.521",
  "quartz-test": "/quartz-test/static-1.531",
  "quartz-tracking": "/quartz-tracking/static-1.235",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3057",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20780",
  "ContentUtils": "/ContentUtils/static-1.68014",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2385",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39320",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12910",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13045",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13932",
  "ExportDialog": "/ExportDialog/static-6.10282",
  "highlight.js": "/highlight.js/static-1.77",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40957",
  "reporting-snowflake": "/reporting-snowflake/static-1.55609",
  "reporting-ui-components": "/reporting-ui-components/static-2.64262",
  "reporting-visualizations": "/reporting-visualizations/static-1.59067",
  "ui-addon-teams": "/ui-addon-teams/static-1.21397",
  "magpie-lib": "/magpie-lib/static-1.5485",
  "magpie-types": "/magpie-types/static-1.4945",
  "simple-logging-lib": "/simple-logging-lib/static-1.2943",
  "navigation-components": "/navigation-components/static-1.17628",
  "ai-studio-lib": "/ai-studio-lib/static-1.11291",
  "app-governance-lib": "/app-governance-lib/static-1.1212",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10398",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7883",
  "ui-product-approvals": "/ui-product-approvals/static-1.27824",
  "ui-tool-access": "/ui-tool-access/static-1.10038",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8308",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5645",
  "usage-tracker-public": "/usage-tracker-public/static-1.7039",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3500",
  "persist-promise": "/persist-promise/static-1.3600",
  "reference-resolvers": "/reference-resolvers/static-1.8058",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3831",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.229",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2898",
  "final-form": "/final-form/static-1.68",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2471",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4962",
  "purchase-motions-components": "/purchase-motions-components/static-1.5667",
  "salesImages": "/salesImages/static-1.523",
  "batch-promise": "/batch-promise/static-1.1443",
  "crm-component-utils": "/crm-component-utils/static-1.38772",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5766",
  "customer-data-properties": "/customer-data-properties/static-1.51159",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6767",
  "property-value-citations": "/property-value-citations/static-1.1773",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7981",
  "navigation-messaging": "/navigation-messaging/static-1.6955",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9713",
  "cms-field-types": "/cms-field-types/static-1.4701",
  "content-icons-ui": "/content-icons-ui/static-1.2196",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7141",
  "crm-message-bus": "/crm-message-bus/static-1.42681",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21755",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9717",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4611",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3919",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6672",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.873",
  "onboarding-tours": "/onboarding-tours/static-1.16403",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13364",
  "academy-common-lib": "/academy-common-lib/static-1.13392",
  "content-assistance-lib": "/content-assistance-lib/static-1.7590",
  "dashboard-lib": "/dashboard-lib/static-1.81070",
  "file-manager-components": "/file-manager-components/static-1.23274",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18189",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17923",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17915",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19645",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8586",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4661",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10865",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8931",
  "user-context": "/user-context/static-1.4991",
  "growth-payments-core": "/growth-payments-core/static-1.25041",
  "reporting-plugins": "/reporting-plugins/static-1.10125",
  "reporting-reports": "/reporting-reports/static-1.66669",
  "idb-keyval": "/idb-keyval/static-1.42",
  "reactive-lib": "/reactive-lib/static-1.616",
  "nest": "/nest/static-1.113",
  "codemirror": "/codemirror/static-5.93",
  "feedback-loader": "/feedback-loader/static-1.29096",
  "react-codemirror": "/react-codemirror/static-1.10515",
  "framework-listing-lib": "/framework-listing-lib/static-2.28352",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30422",
  "apps-service-types": "/apps-service-types/static-1.3769",
  "oauth-service-types": "/oauth-service-types/static-1.4140",
  "onboarding-scopes": "/onboarding-scopes/static-1.6355",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4617",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7577",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14715",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3521",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8899",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4393",
  "nav-client-types": "/nav-client-types/static-1.2250",
  "purchase-motions-api": "/purchase-motions-api/static-1.5670",
  "signup-constants": "/signup-constants/static-1.18641",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7931",
  "trials-service-types": "/trials-service-types/static-1.3794",
  "card-properties-lib": "/card-properties-lib/static-1.43843",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36778",
  "crm-actions": "/crm-actions/static-1.6206",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43249",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9042",
  "customer-data-tracking": "/customer-data-tracking/static-1.6775",
  "hs-resources": "/hs-resources/static-1.29",
  "pulse": "/pulse/static-1.428",
  "calling-global-api": "/calling-global-api/static-1.64085",
  "calling-internal-common": "/calling-internal-common/static-1.31193",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65467",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57761",
  "commerce-products-lib": "/commerce-products-lib/static-1.9134",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3708",
  "crm-links": "/crm-links/static-1.6167",
  "external-options-client-types": "/external-options-client-types/static-1.4069",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4134",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.522",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3600",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48374",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3876",
  "smart-property-lib": "/smart-property-lib/static-1.6410",
  "tiered-pricing": "/tiered-pricing/static-1.998",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10883",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4053",
  "react-dnd-compat": "/react-dnd-compat/static-1.4510",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5263",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2963",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1596",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.469",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7420",
  "academy-service-client": "/academy-service-client/static-1.3572",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28236",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8274",
  "video-components-external": "/video-components-external/static-1.10923",
  "video-data-lib": "/video-data-lib/static-1.34581",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8438",
  "payment-link-components": "/payment-link-components/static-1.23222",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9779",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24137",
  "viral-links-lib": "/viral-links-lib/static-1.6930",
  "data-token-picker": "/data-token-picker/static-1.16216",
  "FileManagerLib": "/FileManagerLib/static-1.38914",
  "react-flip-move": "/react-flip-move/static-1.68",
  "timezone-utils": "/timezone-utils/static-2.5136",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17307",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8618",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7215",
  "customer-data-views-management": "/customer-data-views-management/static-1.25207",
  "framework-data-table": "/framework-data-table/static-2.11660",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6741",
  "nudge-client-utils": "/nudge-client-utils/static-1.2345",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.838",
  "app-users-service-client": "/app-users-service-client/static-1.5448",
  "app-users-service-types": "/app-users-service-types/static-1.4856",
  "mini-checkout-client": "/mini-checkout-client/static-1.26542",
  "onboarding-utils": "/onboarding-utils/static-1.5243",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1999",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28221",
  "edison-service-client-types": "/edison-service-client-types/static-1.279",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3075",
  "crm_data": "/crm_data/static-4.91605",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45703",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15528",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18777",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18245",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10089",
  "crm-fe-perf": "/crm-fe-perf/static-1.22794",
  "directed-graph": "/directed-graph/static-1.829",
  "event-emitter": "/event-emitter/static-1.840",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "calling-error-reporting": "/calling-error-reporting/static-1.31199",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10930",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6433",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.577",
  "commerce-permissions": "/commerce-permissions/static-1.657",
  "products-iframe-lib": "/products-iframe-lib/static-1.7624",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10097",
  "data-agent-kit": "/data-agent-kit/static-1.20",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9798",
  "policy-lib": "/policy-lib/static-1.6674",
  "react-tinymce": "/react-tinymce/static-1.54925",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9861",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54051",
  "tinymce-plugins": "/tinymce-plugins/static-1.57165",
  "tinymce-themes": "/tinymce-themes/static-1.56021",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1779",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1624",
  "user-context-client": "/user-context-client/static-1.4503",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6473",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11878",
  "content-media-compositions": "/content-media-compositions/static-2.15885",
  "media-bridge-lib": "/media-bridge-lib/static-1.18736",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5895",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4978",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3560",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21484",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3735",
  "audio-components": "/audio-components/static-1.5753",
  "FileManagerCore": "/FileManagerCore/static-1.38773",
  "FileManagerImages": "/FileManagerImages/static-1.36425",
  "video-components": "/video-components/static-1.12926",
  "crm-export-dialog": "/crm-export-dialog/static-1.6187",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6327",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1626",
  "tanstack-virtual": "/tanstack-virtual/static-1.28",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2102",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2421",
  "whisper-core-api": "/whisper-core-api/static-1.6284",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14510",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5271",
  "settings-content-modals": "/settings-content-modals/static-1.45767",
  "crm_universal": "/crm_universal/static-1.21818",
  "customer-data-email": "/customer-data-email/static-1.17846",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36832",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39201",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11577",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54357",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21151",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17418",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71573",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5464",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5226",
  "utility-belt": "/utility-belt/static-1.2431",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22319",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7315",
  "customer-data-rte": "/customer-data-rte/static-1.32714",
  "cv-backend-services": "/cv-backend-services/static-1.1536",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5517",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5003",
  "qrcode-generator": "/qrcode-generator/static-1.67",
  "quotes-client-types": "/quotes-client-types/static-1.37663",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35354",
  "sales-views-client-types": "/sales-views-client-types/static-1.4155",
  "hub-http-contrib": "/hub-http-contrib/static-1.2935",
  "interframe": "/interframe/static-3.4655",
  "tinymce-data": "/tinymce-data/static-1.40136",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5103",
  "layout-dnd-components": "/layout-dnd-components/static-1.12236",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11211",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14745",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8979",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4423",
  "video-embed": "/video-embed/static-1.35415",
  "social-insights-client-types": "/social-insights-client-types/static-1.21752",
  "deal-intel-utils": "/deal-intel-utils/static-1.1630",
  "checkout-sdk": "/checkout-sdk/static-3.23385",
  "checkout-service-types": "/checkout-service-types/static-1.3738",
  "company-details-components": "/company-details-components/static-1.6077",
  "payment-method-components": "/payment-method-components/static-1.6788",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13229",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3366",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3418",
  "access-control-lib": "/access-control-lib/static-1.10330",
  "EmailComponents": "/EmailComponents/static-1.54453",
  "EmailData": "/EmailData/static-1.53130",
  "redux-less": "/redux-less/static-2.9376",
  "sequences-lib": "/sequences-lib/static-1.7855",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10240",
  "products-ui-components": "/products-ui-components/static-1.39653",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80294",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6888",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54373",
  "commerce-products-api": "/commerce-products-api/static-1.2124",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56431",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102251",
  "stripe-connect-js": "/stripe-connect-js/static-1.66",
  "draft-content-plugins": "/draft-content-plugins/static-1.27982",
  "ContentData": "/ContentData/static-1.68089",
  "layout-data-lib": "/layout-data-lib/static-1.9536",
  "outpost": "/outpost/static-1.4087",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.782",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3822",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3881",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18369",
  "pricing-pages-api": "/pricing-pages-api/static-1.13094",
  "ContentComponents": "/ContentComponents/static-2.70970",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9499",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1835",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45926",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.788",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18547",
  "automation-ui-types": "/automation-ui-types/static-1.19465",
  "messaging-types-lib": "/messaging-types-lib/static-1.45663",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4395",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7712",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.411",
  "property-description-translator": "/property-description-translator/static-1.3746",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9071",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3548",
  "totals-ui-components": "/totals-ui-components/static-1.23269",
  "advanced-menus-core": "/advanced-menus-core/static-1.14959",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11922",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33743",
  "demographics-service-types": "/demographics-service-types/static-1.1543",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5381",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7232",
  "data-token-views": "/data-token-views/static-1.16197",
  "forms-utils-lib": "/forms-utils-lib/static-1.12375",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12816",
  "simple-menus-core": "/simple-menus-core/static-1.14958",
  "simple-menus-lib": "/simple-menus-lib/static-1.16475",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4146",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6664",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3413",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2549",
  "ContentEditorUI": "/ContentEditorUI/static-2.76794",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3877",
  "web-interactives-components": "/web-interactives-components/static-1.13575",
  "web-interactives-data": "/web-interactives-data/static-1.13576",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.237",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.407",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.868",
  "FireAlarmUi": "/FireAlarmUi/static-1.4421",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4077",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3728",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21401",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20864",
  "data-studio-ubb": "/data-studio-ubb/static-1.2408",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26710",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57455",
  "content-management-data-lib": "/content-management-data-lib/static-1.5248",
  "copilot-plugins": "/copilot-plugins/static-1.10799",
  "cta-picker": "/cta-picker/static-1.36116",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2746",
  "editor-components": "/editor-components/static-1.13073",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8252",
  "error-messaging-js": "/error-messaging-js/static-1.5083",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85559",
  "pictos": "/pictos/static-7.182",
  "react-transition-group": "/react-transition-group/static-2.63",
  "redux-request-state": "/redux-request-state/static-1.10538",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1644",
  "smart-content-core": "/smart-content-core/static-1.42145",
  "smart-content-lib": "/smart-content-lib/static-1.42798",
  "social-composer-lib": "/social-composer-lib/static-1.58539",
  "structured-content-lib": "/structured-content-lib/static-1.24900",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52955",
  "tinymce-copilot": "/tinymce-copilot/static-1.16119",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7747",
  "automation-ui-routing": "/automation-ui-routing/static-1.20822",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5552",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41916",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3050",
  "reporting-enablement": "/reporting-enablement/static-1.22483",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20772",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2252",
  "forms-ai-lib": "/forms-ai-lib/static-1.4149",
  "codemirror-dlb": "/codemirror-dlb/static-1.58353",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6320",
  "report-customization-components": "/report-customization-components/static-1.12817",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12587",
  "html-to-image": "/html-to-image/static-1.52",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1396"
}
};
